import { Modal, FormGroup, FormControl, Row, Col, FormLabel, FormSelect, NavItem } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import { values } from "lodash";
import { useState, useEffect } from "react";
import { format } from "date-fns";
import moment from 'moment';
import { useLazyGetCountriesQuery, useLazyGetPostalCodeQuery } from "app/redux/master/mastersApi";
import {useLazyAddCustomerQuery, useLazyEditCustomerQuery} from "app/redux/Customer/customerApi";
import Select from 'react-select'
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { toast } from "react-toastify";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { useCreateAmsUsersMutation } from "app/redux/AMS/amsApi";
export default function AddCustomerModal({
  show,
  handleFormSubmit,
  toggleEditorDialog,
  customerId,
  initialValues = {}
}) {
const [loader, showLoader, hideLoader] = useFullPageLoader();
const [state, setState] = useState({
  id: 0,
  name: "", personnumber: "", birthDate: "",email: "", phone: "",
  addline1: "", addline2: "", postalcode: "",city: "", country: "Norway", countryId: "163",
  customerNumber: "", bankAccount: "", accountingId: 0,
  loading: false
});
const [countriesList, setCountryListState] = useState([]);
const [getCountries] = useLazyGetCountriesQuery();
const [countryLoading, setCountryLoadingState] = useState(false);

const [postalCodeList, setpostalCodeState] = useState([]);
const [getPostalCode] = useLazyGetPostalCodeQuery();
const [postalCodeLoading, setpostalCodeLoadingState] = useState(false);

const [savingDataLoading, setSavingDataLoadingState] = useState(false);
const [addCustomer] = useLazyAddCustomerQuery();

const[editCustomer] = useLazyEditCustomerQuery();
const [radioValue, setRadioValue] = useState('1');

const [createAmsUsers] = useCreateAmsUsersMutation();

useEffect(() => {
  
  setCountryLoadingState(true);
  getCountries().then((result) => {
    setCountryLoadingState(false);
    //console.log('result - ', result);
    if (result.data) {
      let countryData = result.data.map((e) => ({
        value: e.Id,
        label: e.Name
      }));
      setCountryListState(countryData);
      
    }
  });

  setpostalCodeLoadingState(true);
  getPostalCode().then((result) => {
    setpostalCodeLoadingState(false);
    if (result.data) {
      setpostalCodeState(result.data.data);
    }
  });

  if(initialValues){
    let addLine1 = "";
    let addLine2 = "";
    let postalcode = "";
    let city = "";
    let country = "";
    let countryid = 163;
    if(initialValues && initialValues.Address && initialValues.Address[0]){
      addLine1 = initialValues.Address[0].AddressLine1;
      addLine2 = initialValues.Address[0].AddressLine2;
      postalcode = initialValues.Address[0].ZipCode;
      city = initialValues.Address[0].City;
      country = initialValues.Address[0].Country;
      countryid = initialValues.Address[0].CountryId;
    }
    
  setState({id: customerId,
    name: initialValues.CustomerName, personnumber: initialValues.PersonNumber, birthDate: initialValues.birthDate,email: initialValues.Email,
    phone: initialValues.Phone,
    addline1: addLine1,
    addline2: addLine2,
    postalcode: postalcode,
    city: city,
    country: country,
    countryId: countryid,
    customerNumber: initialValues.customerNumber,
    bankAccount: initialValues.BankAccountNo,
    accountingId: initialValues.accountingId,
    loading: false})
}
  
  
},[customerId])

  const handleSubmit = async (values, { setSubmitting }) => {
    showLoader();
    setSavingDataLoadingState(true);
    if(values.countryId){
      const cntryData = countriesList.filter(a => a.value == values.countryId);
      if(cntryData && cntryData[0]){
        values.country = cntryData[0].label;
      }
    }
    let newFormData = {};
    newFormData.Number = 0;
    newFormData.Name = values.name;
    newFormData.CustomerPostalAddress = {};
    newFormData.CustomerPostalAddress.AddressLine1 = values.addline1; //this.formGroup.controls['customerPostalAdd1'].value;
    newFormData.CustomerPostalAddress.AddressLine2 = values.addline2;
    newFormData.CustomerPostalAddress.City = values.city;
    newFormData.CustomerPostalAddress.County = values.country;
    newFormData.CustomerPostalAddress.CountryId = values.countryId;
    newFormData.CustomerPostalAddress.ZipCode = values.postalcode;

    newFormData.CustomerNickName = values.name;
    newFormData.CustomerNumber = values.customerNumber;
    newFormData.PersonNumber = values.personnumber;
    newFormData.IsPrivateCustomer = true;
    newFormData.CompanyId = localStorage.getItem('CompanyId');
    newFormData.AddedByPersonId = localStorage.getItem('loginUserPersonId');
    newFormData.AddedByUserRoleId = 1;
    newFormData.IsCustomer = 1;
    newFormData.IsSupplier = false;
    newFormData.BankAccount = values.bankAccount;
    newFormData.customerEmail = values.email;
    newFormData.customerPhone = values.phone;

    newFormData.CustomerId = values.id;
    newFormData.IsPrivateCompany = false;
    newFormData.AccountingId = values.accountingId;
    newFormData.IsPostalAddFromBrreg = false;
    newFormData.IsBusinessAddFromBrreg = false;
    newFormData.IsCustomerNameFromBRREG = false;
    newFormData.DOB = values.birthDate;
    newFormData.IsAddressFromBrreg = false;
    newFormData.IsNameFromBrreg = false;
    newFormData.IsEmailFromBRREG = false;
    newFormData.IsPhoneFromBRREG = false;
    newFormData.IsURLFromBRREG = false;
    newFormData.url = '';

    
    if(customerId && customerId > 0){
      //console.log('edit values data - ', newFormData);
      try {
        const result = await editCustomer(newFormData);
        if (result.data.isSuccess) {
          const custId = result.data.data;

          try {
            await createUpdateAMSUser(custId, values);
            hideLoader();
            toast.success("User updated & synced with AMS", { autoClose: 2000 });
          } catch (err) {
            console.error("AMS sync failed", err);
            toast.error("User updated, but AMS sync failed", { autoClose: 3000 });
          }

          handleFormSubmit(custId);
          toggleEditorDialog();
        } else {
          hideLoader();
          toast.error(result.data.message, { autoClose: 2000 });
        }
      } catch (error) {
        hideLoader();
        console.log("edit error", error);
        toast.error(error?.message || "Something went wrong");
      }

    }
    else{
      //console.log('new values data - ', newFormData);
      await addCustomer(newFormData).then((result) => {
        hideLoader();
        if(result.data.isSuccess){
          const custId = result.data.data;
          toast.success("User created successfully", { autoClose: 2000 });
          handleFormSubmit(custId);
          toggleEditorDialog();
        }
        else{
          toast.error(result.data.message, { autoClose: 2000 });
        }
      }, error => {
        hideLoader();
        console.log('edit error', { autoClose: 2000 });
        toast.error(error);
      });
    }
  };

  const createUpdateAMSUser = async (custId, values) => {
    const fullName = values.name?.trim() || "";
    const parts = fullName.split(/\s+/);

    let firstName = "";
    let lastName = "";

    if (parts.length === 1) {
      firstName = parts[0];
      lastName = parts[0];
    } else {
      lastName = parts.pop();
      firstName = parts.join(" ");
    }

    const amsCreateUserPayload = {
      companyId: Number(localStorage.getItem("CompanyId")),
      users: [
        {
          customerId: custId,
          firstName,
          lastName,
          email: values.email,
          phone: values.phone,
          countryCode: "NO",
          propertyUnitId: 0,
          isOwner: false
        }
      ]
    };
    console.log(amsCreateUserPayload);
    return await createAmsUsers(amsCreateUserPayload).unwrap();
  };

  const radios = [
    { name: 'Customer', value: '1' },
    { name: 'Company', value: '2' }
  ];

  return (
    <Modal show={show} onHide={toggleEditorDialog} size="md" className="mt-0">
      <div className="modal-header d-flex justify-content-between align-items-center">
        <h5 className="modal-title" id="exampleModalLabel">
          {initialValues ? "Redigere" : "Legge til"} Bruker
        </h5>

        <span
          className="close fw-bold fs-3 cursor-pointer"
          aria-label="Close"
          onClick={() => toggleEditorDialog(false)}>
          <span aria-hidden="true">&times;</span>
        </span>
      </div>

      <div className="modal-body">
        {/* <ButtonGroup>
          {radios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant={idx % 2 ? 'outline-info' : 'outline-info'}
              name="radio"
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={(e) => setRadioValue(e.currentTarget.value)}
            >
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup> */}
        <Formik
          enableReinitialize={true}
          initialValues={state}
          validationSchema={CustomerSchema}
          onSubmit={handleSubmit}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
                <Row className="mb-1">
                    <FormGroup as={Col} xs={6} className="d-flex flex-column">
                        <FormLabel column sm={2}>Navn</FormLabel>
                        <FormControl
                            placeholder="Navn"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={errors.name && touched.name}
                            className="px-1 mb-2"
                            value={values.name}
                        />
                    </FormGroup>
                    <FormGroup as={Col} xs={6} className="d-flex flex-column">
                        <FormLabel column sm={2}>Personnr</FormLabel>
                        <FormControl
                            placeholder="Personnr"
                            name="personnumber"
                            type="number"
                            onChange={handleChange}
                            onBlur = {handleBlur}
                            className="px-1 mb-2"
                            value={values.personnumber}
                        />
                    </FormGroup>
                    {/* <FormGroup as={Col} xs={4} className="d-flex flex-column">
                        <FormLabel column sm={2}>DOB</FormLabel>
                        <DatePicker
                          className="form-control mb-1 w-100"
                          placeholder="DOB(DD.MM.YYYY)"
                          dateFormat="dd.MM.yyyy"
                          selected={values.birthDate ? new Date(values.birthDate) :''}
                          onChange={(date) => setState({ birthDate: date })}
                        />
                    </FormGroup> */}
                </Row>
                <Row className="mb-1">
                    <FormGroup as={Col} xs={6} className="d-flex flex-column">
                        <FormLabel column sm={4}>E-post</FormLabel>
                        <FormControl
                            placeholder="e-post"
                            name="email"
                            type="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="px-1 mb-2"
                            isInvalid={errors.email && touched.email}
                            value={values.email}
                        />
                    </FormGroup>
                    <FormGroup as={Col} xs={6} className="d-flex flex-column">
                        <FormLabel column sm={2}>Telefonnummer</FormLabel>
                        <FormControl
                            placeholder="Telefonnummer"
                            name="phone"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="px-1 mb-2"
                            value={values.phone}
                        />
                        {errors.phone && touched.phone && (
                          <div className="text-danger">{errors.phone}</div>
                        )}
                    </FormGroup>
                </Row>
                <Row>
                    <fieldset className='border p-2'>
                        <legend className='float-none w-auto'>
                          Postadresse
                        </legend >
                        <Row>
                            <FormGroup>
                                <FormControl
                                    placeholder="Adresselinje 1"
                                    name="addline1"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="px-1 mb-2"
                                    value={values.addline1}
                                />
                            </FormGroup>
                            <FormGroup>
                                <FormControl
                                    placeholder="Adresselinje 2"
                                    name="addline2"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="px-1 mb-2"
                                    value={values.addline2}
                                />
                            </FormGroup>
                            <FormGroup as={Col} xs={6} className="d-flex flex-column">
                                <FormControl
                                    placeholder="postnummer"
                                    name="postalcode"
                                   onChange={handleChange}
                                   onBlur={(e) => {
                                    let tmp = postalCodeList.filter(x => x.ZipCode === values.postalcode);
                                    if(tmp && tmp[0]){
                                      setFieldValue("city", tmp[0].City);
                                      setFieldValue("countryId", tmp[0].CountryID);
                                      setFieldValue("country", tmp[0].country);
                                    }
                                   }
                                  }
                                    className="px-1 mb-2"
                                    value={values.postalcode}
                                />
                            </FormGroup>
                            <FormGroup as={Col} xs={6} className="d-flex flex-column">
                                <FormControl
                                    placeholder="By"
                                    name="city"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="px-1 mb-2"
                                    value={values.city}
                                />
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup>
                            <Select
                              aria-labelledby="aria-label"
                              inputId="aria-example-input"
                              name="aria-live-color"
                              defaultValue={{ label: values.country, value: values.countryId }}
                              options={countriesList}
                              onChange={e => {
                                setState((prevState) => ({ ...prevState, countryId: e.value }))
                             }}
                            />
                            </FormGroup>
                        </Row>
                    </fieldset>
                </Row>
              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => toggleEditorDialog(false)}>
                    Lukke                
                  </button>

                <button type="submit" className="btn btn-primary"
                  // onClick={() => btnSubmitClick(values)}
                  >
                  Lagre
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
      {loader}
    </Modal>
    
  );
}

const CustomerSchema = yup.object().shape({
  name: yup.string().required("tittel er påkrevd"),
  email: yup.string().email().required("e-post er påkrevd"),
  phone: yup
    .string()
    .matches(/^\+?[0-9\- ]+$/, "Ugyldig telefonnummer") // Allows +, -, digits, and spaces
    .required("Telefonnummer er påkrevd")
});

export const setBirthDateFromPersonNumber = (personNumber, birthDate, IsCheckDOB = false) => {
  let DOB = '';
  if (birthDate !== null && birthDate !== undefined && birthDate !== '') {
    DOB = format(birthDate, "yyyy-MM-dd");
    return DOB;
  }
  if (personNumber) {
    var date = new Date();
    if (IsCheckDOB && birthDate) {
      const birthYear = new Date(birthDate).getFullYear();
      const ageInYear = date.getFullYear() - birthYear;
      if (100 >= ageInYear) {
        DOB = format(birthDate, "yyyy-MM-dd");
        return DOB;
      }
    }
    const currentYear = date.getFullYear();
    const dt = personNumber.toString().substring(0, 2);
    const mo = personNumber.toString().substring(2, 4) - 1;
    const yy = personNumber.toString().substring(4, 6)
    date.setDate(dt);
    date.setMonth(mo);
    const year = yy;
    if (year >= 0 && year < 30) {
      date.setFullYear(20 + yy);
    } else {
      date.setFullYear(19 + yy);
    }
    if (currentYear < date.getFullYear()) {
      this.toasterService.pop('warning', 'Legg til kundekontakt', 'Invalid personnumber or DOB');
      return;
    }
    DOB = format(date, "yyyy-MM-dd");
    return DOB;
  } else {
    return '';
  }

}